export default __webpack_public_path__ + "static/media/Version (4) - Half-Blood Prince_22.68904c49.jpg";